import { render, staticRenderFns } from "./hospital_in.vue?vue&type=template&id=7e671f06&scoped=true"
import script from "./hospital_in.vue?vue&type=script&lang=js"
export * from "./hospital_in.vue?vue&type=script&lang=js"
import style0 from "./hospital_in.vue?vue&type=style&index=0&id=7e671f06&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e671f06",
  null
  
)

export default component.exports